import React from 'react'
import GenericCustomButton from '../../genericComponents/GenericCustomButton';
import Lottie from 'lottie-react';
import JobSuccessTickMarkGreen from '../../animationsJSON.js/WhiteSuccessLotti.json'
const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: JobSuccessTickMarkGreen,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    },
    style: {
        width: 150,
        height: 150
    }
};

const MergeSuccessModal = (props) => {

    const { submitModal,buttonLabel = "Complete Process" } = props;

    return (
        <div className='acc-setup-cmpltd h-full w-full flex items-center rounded-[5px] overflow-hidden'>
            <div className="setup-cmpltd w-[45%] h-full flex-[0_0_45%] bg-[#24A148] text-center flex flex-col justify-between p-[40px]">
                <div className='sc-top flex flex-col items-center'>
                    <Lottie
                        {...defaultOptions}
                    />
                    <div className="sc-content py-[25px] px-0">
                        <label className='text-[19px] font-bold text-white'>Account Merge Successful</label>
                        <p className='text-white text-xs font-normal m-[0] pt-[15px]'>You can now login with your primary account to access all your merged accounts.</p>
                    </div>
                </div>
                <div className="sc-bot flex items-center justify-center">
                    <GenericCustomButton
                        sendEventAnalyticsToGoogle = {true}
                        eventAnlyticsLabel = {"Account Merge Complete Process"}
                        type="normal"
                        label={buttonLabel}
                        onClick={() => {
                            submitModal();
                        }}
                        className={'w-[228px] h-[44px] bg-white text-[#24A148] rounded-[3px] text-[13px] font-semibold'}
                    />
                </div>
            </div>
            <div className="switch-org w-[55%] flex-[0_0_55%] h-full bg-[#edf3fa] text-center pt-[30px] p-[20px] flex flex-col">
                <p className='m-[0] text-lg font-semibold text-[#2A2A64]'>See below how you can switch between your organizations !</p>
                <div className='success-img mt-[10px] overflow-hidden w-full h-full'>
                    <img className='w-full h-full object-contain object-center' src={require('../../assets/images/organization-switch.gif')} />
                </div>
            </div>
        </div>
    )
}

export default MergeSuccessModal